<script>
export default {
    name: "SupplierJournalList",

    data() {

        return {
            approvedJournals: [],
            pendingJournals: [],
            active: 0,
            activeClass: `bg-gray-100 border-l-2 border-r-2 border-t-2 border-gray-500 rounded-t-md z-10 -mb-1`,
            inActiveClass: `bg-gray-300 border-l border-r border-t`,
        };
    },

    components: {

       "journal-list": () => import('./list/Approved.vue'),
    },

    mounted() {

       this.$root.loading = true;
       Promise.allSettled([ this.fetchApprovedJournals(), this.fetchPendingJournals(), ])
         .then(() => { this.$root.loading = false; })
         .catch(() => { this.$root.loading = false; });
    },

    methods: {

       fetchApprovedJournals() {

          return this.$accountsHttp.get(`SupplierJournal/ApprovedSupplierJournals`).then(response => {
               this.approvedJournals = response.data;
          }).catch(() => { });
       },

       fetchPendingJournals() {

          return this.$accountsHttp.get(`SupplierJournal/NotApprovedSupplierJournals`).then(response => {
               this.pendingJournals = response.data;
          }).catch(() => {});
       },
    },
}
</script>

<template>
<tail-base-layout>
  <template v-slot:content>
      <tail-card>
        <template v-slot:card-header>
          <div class="flex w-full">
             <div class="flex-1"><h5 class="font-medium text-sm">Supplier Journals</h5></div>
             <div class="flex-1 flex justify-end">
                <router-link :to="{ name: 'suppliers-dashboard.journals.create'}" class="btn-info btn-sm text-xs"><i class="fa fa-plus"></i> Journal</router-link>
             </div>
          </div>
        </template>
        <template v-slot:card-body>
            <div class="w-full">
                <ul class="flex border-b">
                  <li class="-mb-px mr-1">
                        <a @click.prevent="active=0" 
                        class="btn-sm text-sm text-gray-900 rounded-t-md inline-block px-4 font-bold whitespace-no-wrap" 
                        :class="active == 0 ? activeClass : inActiveClass" href="javascript:void()">Pending</a>
                  </li>
                  <li class="-mb-px mr-1">
                    <a @click.prevent="active=1" 
                       class="btn-sm text-sm text-gray-900 rounded-t-md inline-block px-4 font-bold whitespace-no-wrap" 
                       :class="active == 1 ? activeClass : inActiveClass" href="javascript:void()">Approved</a>
                  </li>
                </ul>
                <div v-if="active==0">
                    <journal-list :journals="pendingJournals" />
                </div>
                <div v-if="active==1">
                    <journal-list :journals="approvedJournals" />
                </div>
            </div>
        </template>
        <template v-slot:card-footer>
           <div class="w-full text-right">
             <router-link :to="{ name: `suppliers-dashboard.index` }" class="btn-sm btn-danger text-xs rounded"><i class="fa fa-caret-left"></i> Back</router-link>
           </div>
        </template>
      </tail-card>
  </template>
</tail-base-layout>
</template>
